import FoodOrdersListPanel from '../../components/food/FoodOrdersListPanel';
import PageShell from '../../components/layout/PageShell';
import PageHeader from '../../components/layout/PageHeader';

export default function FoodOrderHistoryPage() {
  return (
    <PageShell>
      <PageHeader title="Food Order History" subtitle="Delivered, cancelled, and refunded food orders" />
      <FoodOrdersListPanel scope="history" title="Past Orders" />
    </PageShell>
  );
}
